const PRINCIPAL_ACCOUNT = 'PRINCIPAL';
const MULTIBAL_ACCOUNT = 'MULTIBAL';
const MOBILE_ACCOUNT = 'EXTERNAL';
const NSRU_ACCOUNT = 'NSRU';

const MOBILE_TYPE = 'M';
const EMAIL_TYPE = 'E';

const CONTACT_DECLARED_STATUS = 'declared';

export { PRINCIPAL_ACCOUNT, MULTIBAL_ACCOUNT, MOBILE_ACCOUNT, NSRU_ACCOUNT, MOBILE_TYPE, EMAIL_TYPE, CONTACT_DECLARED_STATUS }